import Link from "next/link";

// The Playground tab: editing and re-running a moment happens on the
// Playground page, seeded from this moment.
const AgentMomentPlaygroundLink = ({
  sessionId,
  agentId,
  momentId,
}: {
  sessionId: string;
  agentId: string;
  momentId: number;
}) => (
  <div className="d-flex flex-column align-items-start gap-3">
    <p className="mb-0">
      Edit this moment's inputs and re-run them in the Playground.
    </p>
    <Link
      className="btn btn-primary"
      href={{
        pathname: "/playground",
        query: {
          sourceSession: sessionId,
          sourceAgent: agentId,
          sourceMoment: momentId,
        },
      }}
      data-testid="agent-moment-playground-link"
    >
      <i className="bi-play-fill me-1" />
      Open in Playground
    </Link>
  </div>
);

export default AgentMomentPlaygroundLink;
